import { BACKGROUND_INIT, BACKGROUND_UPDATE } from 'redux/types/background.types';
import { INITIAL_PICK_COLOR } from 'utils/background';

// mode: default | color | image；pendingFile：已選但還沒上傳的圖（按儲存才上傳）；previewUrl：它的本機預覽網址
const BACKGROUND_RES = {
    mode: 'default',
    color: INITIAL_PICK_COLOR,
    bgImage: '',
    pendingFile: null,
    previewUrl: '',
};

const backgroundReducer = (state = BACKGROUND_RES, action) => {
    switch (action.type) {
        case BACKGROUND_INIT:
            return { ...BACKGROUND_RES, ...action.payload };
        case BACKGROUND_UPDATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default backgroundReducer;
